import type { ProjectFilters, ProjectsState } from "./projects.types.ts"

/** `imported` comes from a link, so it is never remembered across visits. */
const withoutLinkFilters = (filters: ProjectFilters): ProjectFilters => {
  const { imported: _imported, ...kept } = filters
  return kept
}

export const persistedProjectFilters = (
  state: Partial<ProjectsState> | undefined
): Partial<ProjectsState> => {
  if (!state) return {}
  const kept: Partial<ProjectsState> = {}
  if ("listFilters" in state && state.listFilters)
    kept.listFilters = withoutLinkFilters(state.listFilters)
  if ("gridFilters" in state && state.gridFilters)
    kept.gridFilters = withoutLinkFilters(state.gridFilters)
  return kept
}
